import React from 'react';
import PendingReceivedInvitations from './PendingReceivedInvitations';
import PendingSentInvitations from './PendingSentInvitations';
import { useIsMobile } from 'app/hooks/useIsMobile';
import { api } from 'services/api';
import useFlag from 'app/hooks/useFlag';
import { FeatureName } from 'types/entities/MobileSettings';

function PendingInvitations() {
  const isMobile = useIsMobile();
  const isAccessSharingPageEnabled = useFlag(FeatureName.ACCESS_SHARING);

  const {
    data: invitations = {
      pendingReceivedInvitations: [],
      pendingSentInvitations: [],
    },
  } = api.useGetInvitationsQuery(undefined, {
    skip: !isAccessSharingPageEnabled,
  });

  return (
    <div>
      <PendingReceivedInvitations
        isMobile={isMobile}
        invitations={invitations.pendingReceivedInvitations}
      />
      <PendingSentInvitations
        isMobile={isMobile}
        invitations={invitations.pendingSentInvitations}
      />
    </div>
  );
}

export default PendingInvitations;
